// extracted by mini-css-extract-plugin
export var authorDetails = "FeaturedBlog-module--authorDetails--49800";
export var authorImg = "FeaturedBlog-module--authorImg--1af5e";
export var blogExcerpt = "FeaturedBlog-module--blogExcerpt--cbf63";
export var excerpt = "FeaturedBlog-module--excerpt--36718";
export var featuredBlog = "FeaturedBlog-module--featuredBlog--e7df4";
export var middle = "FeaturedBlog-module--middle--a162a";
export var timeToRead = "FeaturedBlog-module--timeToRead--d7de4";
export var titleLink = "FeaturedBlog-module--titleLink--5b904";
export var top = "FeaturedBlog-module--top--72924";
export var whiteDiagonal = "FeaturedBlog-module--whiteDiagonal--12903";